const ExportOnce = {
  mounted() {
    this.iconElement = this.el.querySelector("svg");
    if (!this.iconElement) {
      console.error("ExportOnce hook couldn't find an svg icon.");
      return;
    }

    // Store the original icon HTML
    this.originalIcon = this.iconElement.outerHTML;
    this.disabled = false;

    this.el.addEventListener("click", (e) => {
      if (this.disabled) {
        e.preventDefault();
        return;
      }

      // Disable the main link element
      this.disabled = true;
      this.el.style.pointerEvents = "none";
      this.el.style.opacity = "0.7";

      // Replace the icon with a spinner
      this.iconElement.outerHTML = `<svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>`;

      // console.log("Initiating export...");

      setTimeout(() => {
        this.disabled = false;
        // Find the icon element again as it was replaced
        this.iconElement = this.el.querySelector("svg");
        // Restore the original icon
        this.iconElement.outerHTML = this.originalIcon;
        // Re-enable the main link element
        this.el.style.pointerEvents = "auto";
        this.el.style.opacity = "1";
        // console.log("Export link re-enabled.");
      }, 3000);
    });
  },
};

export default ExportOnce;
